"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = useShortcut;

var _react = _interopRequireDefault(require("react"));

var _index = require("../ShortcutProvider/index.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function useShortcut(ordered, onMatch) {
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

  var shortcutManager = _react["default"].useContext(_index.ShortcutContext);

  var subscription = _react["default"].useRef(null);

  var node = options.node,
      held = options.held,
      ignoreInput = options.ignoreInput,
      allowDefault = options.allowDefault;

  _react["default"].useEffect(function () {
    if (node != null) {
      return;
    }

    if (shortcutManager == null) {
      return;
    }

    subscription.current = shortcutManager.subscribe({
      onMatch: onMatch,
      ordered: ordered,
      node: node,
      held: held,
      ignoreInput: ignoreInput || false,
      allowDefault: allowDefault || false
    });
    return function () {
      if (subscription.current == null) {
        return;
      }

      subscription.current.unsubscribe();
    };
  }, [node, ordered, onMatch, held, ignoreInput, allowDefault, shortcutManager]);
}